import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Grid,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";

export default function MedViewDetails({ open, onClose, details }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            maxWidth: "unset",
            width: { xs: "95vw", md: "800px" },
            borderRadius: "10px",
          },
        },
      }}
    >
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h6">Medicine Request Details</Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={2}>
          {/* Requested By */}
          <Grid item xs={12} sm={6}>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Typography variant="body2" fontWeight="bold">
                Requested By:
              </Typography>
              <Typography variant="body2">
                {`${details?.requestedBy?.firstName || ""} ${
                  details?.requestedBy?.lastName || ""
                }` || "-"}
              </Typography>
            </Box>
          </Grid>

          {/* Requested Date */}
          <Grid item xs={12} sm={6}>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Typography variant="body2" fontWeight="bold">
                Requested Date:
              </Typography>
              <Typography variant="body2">
                {details?.requestedDate
                  ? dayjs(details?.requestedDate).format("YYYY-MM-DD")
                  : "-"}
              </Typography>
            </Box>
          </Grid>

          {/* Invoice Number */}
          <Grid item xs={12} sm={6}>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Typography variant="body2" fontWeight="bold">
                Invoice Number:
              </Typography>
              <Typography variant="body2">
                {details?.invoiceNumber || "-"}
              </Typography>
            </Box>
          </Grid>

          {/* Requested Time */}
          <Grid item xs={12} sm={6}>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Typography variant="body2" fontWeight="bold">
                Requested Time:
              </Typography>
              <Typography variant="body2">
                {details?.requestedDate
                  ? dayjs(details?.requestedDate).format("hh:mm A")
                  : "-"}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
